/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

const images = require.context('../../assets/images', true);

function importAll(r) {
  r.keys().forEach(r);
}

import 'jquery';
import 'jquery.cookie';
import 'jquery-ui/ui/version';
import 'jquery-ui/ui/widget';
import 'jquery-ui/ui/keycode';
import 'jquery-ui/ui/unique-id';
import 'jquery-ui/ui/effect';
import 'jquery-ui/ui/effects/effect-slide';
import 'jquery-ui/ui/widgets/accordion';
import 'spin';
import 'purl';
import 'rails-ujs';

import 'angular';
import 'angular-messages';
import 'angular-animate';

import 'slick-slider';

import 'unisporkal_engine/webpack/base';
import 'unisporkal_engine/shared/jquery.modalSpinner';
import 'unisporkal_engine/shared/jquery.inlineSpinner';
import 'unisporkal_engine/shared/jquery.safeFunctions.js';
import 'unisporkal_engine/shared/jquery.gettyModal';
import 'unisporkal_engine/shared/jquery.popupWindow';
import 'unisporkal_engine/webpack/carousel';
import 'unisporkal_engine/webpack/tooltip';
import 'unisporkal_engine/webpack/modal';

import '@unisporkal/unisporkal-engine/app/assets/images/unisporkal_engine/getty_images_no_trademark.svg';
import '@unisporkal/unisporkal-engine/app/assets/images/unisporkal_engine/istock_header_logo.svg';

import 'unisporkal_engine/recaptcha/recaptcha_directive';

// GA4 tracking
import '@unisporkal/ga4/events-queue-tracking';
import '@unisporkal/ga4/set-previous-page-data';

importAll(
  require.context(
    '!ngtemplate-loader?relativeTo=templates/!html-loader!slim-lang-loader!templates',
    true,
    /\.html$/
  )
);
importAll(
  require.context(
    '!ngtemplate-loader?relativeTo=icons/&prefix=icons!html-loader!icons',
    true,
    /\.svg$/
  )
);

import 'landing_page';
import 'front_door_page';
import 'customer_support_module';
importAll(require.context('../../assets/javascripts', true, /\.js$/));
import 'shared/jquery.captcha.js';
import 'application_init';

import './react';

if (module.hot) {
  module.hot.accept();
}
